import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import AdBanner from '../components/AdBanner';
import { Construction } from 'lucide-react';

export default function ComingSoon({ title }) {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-surface app-shell pb-28">
            <div className="px-6">
                <TopBar onPremiumClick={() => {}} onBellClick={() => {}} onMenuClick={() => navigate('/home')} />

                <div className="mt-8 fade-up">
                    <h1 className="text-3xl font-bold text-brand-navy tracking-tight">{title}</h1>
                    <p className="text-gray-500 mt-1">Próximamente</p>
                </div>

                <div className="mt-10 bg-white rounded-[24px] shadow-card p-8 text-center fade-up fade-up-delay-1">
                    <div className="w-20 h-20 bg-brand/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Construction className="w-10 h-10 text-brand" />
                    </div>
                    <h2 className="text-xl font-bold text-brand-navy mb-2">En construcción</h2>
                    <p className="text-gray-500 text-sm leading-relaxed">
                        Esta sección será construida en las próximas fases. Por ahora has completado la <strong>Fase 0</strong> con éxito.
                    </p>
                </div>
            </div>

            <div className="fixed bottom-[72px] left-1/2 -translate-x-1/2 w-full max-w-[480px] z-30">
                <AdBanner />
            </div>

            <BottomNav />
        </div>
    );
}
